<template>
  <ProductPageSideBarLayout >
    <section class="base-page">
    <ProductPageHeader />
    <keep-alive><FilterSection @change="onFilterChange"/></keep-alive>
    <BasicTable
      showSelection
      :loading="tableLoading"
      :tableColumns="tableColumns"
      :tableData="tableData"
      :page="page"
      :size="size"
      :total="total"
      :orderDirection="orderDirection"
      :orderProp="orderProp"
      @onSortChange="onTableSortChange"
      @onSizeChange="handleSizeChange"
      @onPageChange="handlePageChange"
      @onRefresh="onRefresh"
      @onClearAndRefresh="onClearAndRefresh"
      @onSelectionChange="onSelectionChange"
    >
      <template #tableControl>
        <el-button
          size="small"
          class="mt-r"
          type="primary"
          icon="el-icon-document-add"
          @click="addRow"
          v-if="checkPermission(['PRODUCT_ADMIN'])"
          >新增</el-button
        >
        <el-button
          class="mt-r"
          size="small"
          type="primary"
          icon="el-icon-circle-plus"
          @click="showAsyncCreator = true"
          >从唯格云添加</el-button
        >
        <!-- <el-button
          size="small"
          class="mt-r"
          type="primary"
          icon="el-icon-document-add"
          @click="getViewgresProductList"
          >获取唯格云的产品信息</el-button
        > -->

        <el-checkbox class="mt-l mt-r" v-model="showDisable" @change="onSearch"
          >显示禁用</el-checkbox
        >
        &nbsp; &nbsp;
      </template>
      <template v-for="column in tableColumns">
        <el-table-column
          v-if="column.prop !== 'controlColumn' && column.showColumn"
          v-bind="column"
          :show-overflow-tooltip="true"
          :key="column.prop"
        >
          <template slot-scope="scope">
            <span v-if="column.prop === 'disabled'">
              <el-tag
                :type="scope.row.disabled ? 'danger' : 'success'"
                @click="toggleDisableRow(scope.row, scope.$index)"
                >{{ scope.row.disabled ? "已禁用" : "已启用" }}</el-tag
              >
            </span>
            <span v-else-if="column.prop === 'vgc_product_id'">
              <span class="text-nav" @click="handleBindVgcProduct(scope.row)">{{
                scope.row.vgc_product_id == null
                  ? "点击绑定"
                  : scope.row.vgc_product_id
              }}</span>
            </span>
            <span v-else-if="column.prop === 'utc_create'">
              {{ scope.row.utc_create | date }}
            </span>
            <span v-else-if="column.prop === 'utc_modified'">
              {{ scope.row.utc_modified | date }}
            </span>
            <span v-else-if="column.prop === 'poster_image_url'">
              <el-image
                style="width: 50px; height: 50px"
                :src="scope.row.poster_image_url"
                :preview-src-list="[scope.row.poster_image_url]"
              >
              </el-image>
            </span>
            <span v-else-if="column.prop === 'cover_image_url'">
              <el-image
                style="width: 50px; height: 50px"
                :src="scope.row.cover_image_url"
                :preview-src-list="[scope.row.cover_image_url]"
              >
              </el-image>
            </span>
            <span v-else-if="column.prop === 'rendering_image_url'">
              <el-image
                style="width: 50px; height: 50px"
                :src="scope.row.rendering_image_url"
                :preview-src-list="[scope.row.rendering_image_url]"
              >
              </el-image>
            </span>
            <span v-else-if="column.prop === 'thumbnail_url'">
              <el-image
                style="width: 50px; height: 50px"
                :src="scope.row.thumbnail_url"
                :preview-src-list="[scope.row.thumbnail_url]"
              >
              </el-image>
            </span>

            <span v-else-if="column.prop === 'name'">
              <div class="text-nav" @click="handleShowDetail(scope.row)">
                <div>{{ scope.row.name ? scope.row.name.cn : "" }}</div>
                <div>{{ scope.row.name ? scope.row.name.en : "" }}</div>
              </div>
            </span>
            <span v-else-if="column.prop === 'star'">
              <span>{{ scope.row.star ? "星标" : "非星标" }}</span>
            </span>

            <span v-else-if="column.prop === 'color_name'">
              <span>{{
                scope.row.color_name ? scope.row.color_name.cn : ""
              }}</span>
            </span>
            <span v-else-if="column.prop === 'introduction'">
              <span>{{
                scope.row.introduction ? scope.row.introduction.cn : ""
              }}</span>
            </span>
            <span v-else-if="column.prop === 'description'">
              <span>{{
                scope.row.description ? scope.row.description.cn : ""
              }}</span>
            </span>
            <span v-else-if="column.prop === 'oneline_description'">
              <span>{{
                scope.row.oneline_description
                  ? scope.row.oneline_description.cn
                  : ""
              }}</span>
            </span>
            <span v-else-if="column.prop === 'series'">
              <span>{{
                scope.row.series.map(item => item.name).join(",")
              }}</span>
            </span>
            <span v-else-if="column.prop === 'albums'">
              <el-popover
                placement="right"
                width="450"
                trigger="click"
                v-if="scope.row.albums.length > 0"
              >
                <el-carousel height="300px">
                  <el-carousel-item
                    v-for="item in scope.row.albums"
                    :key="item.url"
                    :title="`${item.name.cn}`"
                  >
                    <img
                      :src="item.url"
                      alt="图册"
                      class="preview-img contain"
                    />
                  </el-carousel-item>
                </el-carousel>
                <span class="text-nav" slot="reference"
                  >{{ scope.row.albums.length }}张</span
                >
              </el-popover>
              <span v-else>暂无图片</span>
            </span>
            <span v-else-if="column.prop === 'photos'">
              <el-popover
                placement="right"
                width="450"
                trigger="click"
                v-if="scope.row.photos.length > 0"
              >
                <el-carousel height="300px">
                  <el-carousel-item
                    v-for="item in scope.row.photos"
                    :key="item.url"
                    :title="`${item.type_name}`"
                  >
                    <img
                      :src="item.url"
                      alt="实拍图"
                      class="preview-img contain"
                    />
                  </el-carousel-item>
                </el-carousel>
                <span class="text-nav" slot="reference"
                  >{{ scope.row.photos.length }}张</span
                >
              </el-popover>
              <span v-else>暂无图片</span>
            </span>
            <span v-else-if="column.prop === 'element_medias'">
              <el-popover
                placement="right"
                width="450"
                trigger="click"
                v-if="scope.row.element_medias.length > 0"
              >
                <el-carousel height="300px">
                  <el-carousel-item
                    v-for="item in scope.row.element_medias"
                    :key="item.url"
                    :title="`${item.type_name}`"
                  >
                    <img
                      :src="item.url"
                      alt="元素图"
                      class="preview-img contain"
                    />
                  </el-carousel-item>
                </el-carousel>
                <span class="text-nav" slot="reference"
                  >{{ scope.row.element_medias.length }}张</span
                >
              </el-popover>
              <span v-else>暂无图片</span>
            </span>
            <span v-else-if="column.prop === 'files'">
              <el-popover
                placement="right"
                width="300"
                trigger="click"
                v-if="scope.row.files.length > 0"
              >
                <ul class="series-file-list">
                  <li
                    class="list-item"
                    v-for="item in scope.row.files"
                    :key="item.url"
                    :title="`${item.nameCn} | ${item.nameEn}`"
                  >
                    <a
                      :href="item.url"
                      target="_blank"
                      rel="noopener noreferrer"
                      :download="item.nameEn"
                    >
                      <p>中文: {{ item.name.cn }}</p>
                      <p>英文: {{ item.name.en }}</p>
                    </a>
                  </li>
                </ul>
                <span class="text-nav" slot="reference"
                  >{{ scope.row.files.length }}个文件</span
                >
              </el-popover>
              <span v-else>暂无文件</span>
            </span>

            <span v-else>{{ scope.row[column.prop] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="column.prop === 'controlColumn' && column.showColumn"
          v-bind="column"
          :key="column.prop"
        >
          <template slot-scope="scope">
            <el-dropdown>
              <span class="el-dropdown-link drop-down-menu-link">
                更多操作<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-if="scope.row.canUpdate"
                  @click.native.prevent="editRow(scope.row, scope.$index)"
                  >编辑</el-dropdown-item
                >
                <el-dropdown-item
                  v-if="scope.row.canUpdate"
                  @click.native.prevent="handleCopy(scope.row, scope.$index)"
                  >复制</el-dropdown-item
                >

                <el-dropdown-item
                  v-if="scope.row.canDisable"
                  :class="[scope.row.disabled ? 'text-success' : 'text-danger']"
                  @click.native.prevent="
                    toggleDisableRow(scope.row, scope.$index)
                  "
                >
                  {{ scope.row.disabled ? "启用" : "禁用" }}</el-dropdown-item
                >
                <el-dropdown-item
                  @click.native.prevent="handleBindVgcProduct(scope.row)"
                  >绑定唯格云产品</el-dropdown-item
                >
                <el-dropdown-item
                  @click.native.prevent="updateByVgcId(scope.row)"
                  >同步内容</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </template>
      <template #multipleControl>
        <el-button
          class="mt-r"
          size="small"
          @click="onMultipleToggleDisable(false)"
          :disabled="multipleSelected.length <= 0"
          >启用 {{ multipleSelected.length }}</el-button
        >
        <el-button
          class="mt-r"
          size="small"
          @click="onMultipleToggleDisable(true)"
          :disabled="multipleSelected.length <= 0"
          >禁用 {{ multipleSelected.length }}</el-button
        >
        <el-button
          class="mt-r"
          size="small"
          @click="onUpdateSerires"
          :disabled="multipleSelected.length <= 0"
          >更新系列 {{ multipleSelected.length }}</el-button
        >
      </template>
    </BasicTable>
    <UpdateSeriesOfProducts
      :show="showUpdateSeriesDialog"
      :pids="multipleSelectedIds"
      @success="onUpdateSeriesSuccess"
      @close="onUpdateSeriesClose"
    />
    <AsyncCreator :show="showAsyncCreator" @close="onAsyncCreatorClose" />
    <VgcProductPikcer
      :show="showVgcProductPicker"
      :query="bindQuery"
      @change="onVgcProductPickerChange"
      @close="onVgcProductPickerClose"
    />
    <ProductDetail
      :show="showProductDetail"
      :sid="currentId"
      @close="showProductDetail = false"
    />
  </section>
  </ProductPageSideBarLayout>
  
</template>

<script>
import BasicTable from "@/components/BasicTable";
import { GetProductsList, ToogleDisableByIds, PutProducts } from "./api";
import AsyncCreator from "./components/AsyncCreator.vue";
import VgcProductPikcer from "./components/VgcProductPikcer.vue";
import ProductDetail from "./components/ProductDetail.vue";
import {
  GetUpdateSeriesCheck,
  GetDisableCheck,
  GetUpdateCheck
} from "./api/check";
import { ShowApiError } from "@/request/error";
import { isEmprty } from "@/utils/validate";
import { checkPermission } from "@/utils/auth";
import {
  GetTableOrderParams,
  onClearFilter,
  FormatMultipleItemIds,
  GetTableDisableMessage
} from "@/utils/table";
import ProductPageHeader from "@/components/ProductPageHeader";
import ProductPageSideBarLayout from "@/components/ProductPageSideBarLayout"
import UpdateSeriesOfProducts from "@/views/products/components/UpdateSeriesOfProducts";
import FilterSection from "./components/FilterSection";
import config from "@/config";
import form from "./mixins/form";
import table from "./mixins/table";
import { buildI18nKeyValue } from "@/utils/common";
export default {
  components: {
    BasicTable,
    FilterSection,
    ProductPageHeader,
    ProductPageSideBarLayout,
    UpdateSeriesOfProducts,
    AsyncCreator,
    VgcProductPikcer,
    ProductDetail
  },
  mixins: [form, table],
  data() {
    return {
      showAsyncCreator: false,
      showVgcProductPicker: false,
      showProductDetail: false,
      formDialog: false,
      tableLoading: false,
      multipleFormDialog: false,
      tableColumns: [],
      page: 0,
      size: config.TABLE_SIZE,
      total: 0,
      tableData: [],
      tableFilters: {},
      orderProp: "seq",
      orderDirection: "descending",
      currentId: null,
      currentCopyId: null,
      multipleSelected: [],
      showDisable: false,
      orderPropObj: {},
      showUpdateSeriesDialog: false,
      bindDataItem: null,
      bindQuery: {
        nameCn: ""
      }
    };
  },
  computed: {
    images() {
      return this.tableData.map(item => item.menuImageUrl);
    },
    localeColumns() {
      return this.$store.getters.localeColumns;
    },
    multipleSelectedIds() {
      return this.multipleSelected.map(item => item.id);
    }
  },
  created() {
    this.buildTableColumns();
    this.getTableData();
  },
  methods: {
    isEmprty,
    checkPermission,
    handleBindVgcProduct(row) {
      this.bindDataItem = row;
      this.bindQuery = {
        nameCn: row.name.cn
      };
      this.showVgcProductPicker = true;
    },
    async onVgcProductPickerChange(data) {
      if (this.bindDataItem == null) {
        return;
      }
      let message = this.$message({
        message: "正在绑定...",
        type: "info",
        duration: 0,
        iconClass: "el-icon-loading"
      });
      try {
        let formData = this.buildForm();
        for (const key in this.bindDataItem) {
          if (Object.hasOwnProperty.call(formData, key)) {
            let keys = [
              "name",
              "introduction",
              "description",
              "oneline_description",
              "poster_slogan"
            ];
            if (keys.includes(key)) {
              formData[key] = buildI18nKeyValue(this.bindDataItem[key]);
            } else {
              formData[key] = this.bindDataItem[key];
            }
          }
        }
        formData = {
          ...formData,
          vgcProductId: data[0].id,
          id: this.bindDataItem.id,
          code: this.bindDataItem.code == "" ? null : data[0].code,
          normalMedias: this.formatArrData(this.bindDataItem.normal_medias),
          elementMedias: this.formatArrData(this.bindDataItem.element_medias),
          photos: this.formatArrData(this.bindDataItem.photos),
          albums: this.formatArrData(this.bindDataItem.albums),
          files: this.formatArrData(this.bindDataItem.files),
          seriesIds: this.bindDataItem.series.map(item => item.id)
        };
        // console.log("提交绑定的表单formData", formData);
        await PutProducts([formData]);
        message.close();
        this.$message.success("绑定成功");
        this.bindDataItem = null;
        this.onVgcProductPickerClose();
        this.getTableData();
      } catch (error) {
        message.close();
        ShowApiError("绑定失败", error);
      }
    },
    onVgcProductPickerClose() {
      this.showVgcProductPicker = false;
      this.bindQuery = {};
    },
    onAsyncCreatorClose() {
      this.showAsyncCreator = false;
      this.getTableData();
    },
    handleShowDetail(row) {
      this.currentId = row.id;
      this.showProductDetail = true;
    },

    buildTableColumns(columns = []) {
      if (columns.length > 0) {
        this.tableColumns = columns;
      } else {
        this.tableColumns = [
          {
            prop: "disabled",
            label: "状态",
            showColumn: true,
            width: 100,
            align: "center",
            fixed: "left",
            sortable: "custom"
          },
          {
            prop: "thumbnail_url",
            label: "元素图",
            showColumn: true,
            width: 100,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "cover_image_url",
            label: "效果图",
            showColumn: true,
            width: 100,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "rendering_image_url",
            label: "渲染图",
            showColumn: true,
            width: 100,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "vgc_product_id",
            label: "唯格云产品ID",
            showColumn: true,
            width: 130,
            align: "center",
            sortable: "custom"
          },

          {
            prop: "name",
            label: "名称",
            minWidth: 150,
            showColumn: true,
            align: "left",
            sortable: "custom"
          },

          // {
          //   prop: "introduction",
          //   label: "简介",
          //   minWidth: 150,
          //   showColumn: true,
          //   align: "left",
          //   sortable: "custom",
          // },
          // {
          //   prop: "description",
          //   label: "描述",
          //   showColumn: true,
          //   align: "left",
          //   sortable: "custom",
          // },

          {
            prop: "element_medias",
            label: "元素图",
            width: 150,
            showColumn: true,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "series",
            label: "系列",
            minWidth: 150,
            showColumn: true,
            align: "left",
            sortable: "custom"
          },
          {
            prop: "color_name",
            label: "色系",
            minWidth: 150,
            showColumn: true,
            align: "left",
            sortable: "custom"
          },

          {
            prop: "code",
            label: "编号",
            minWidth: 80,
            showColumn: true,
            align: "left",
            sortable: "custom"
          },
          {
            prop: "oneline_description",
            label: "一句话描述",
            minWidth: 160,
            showColumn: true,
            align: "left",
            sortable: "custom"
          },
          {
            prop: "albums",
            label: "图册",
            width: 120,
            showColumn: true,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "photos",
            label: "实拍图",
            width: 120,
            showColumn: true,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "files",
            label: "附件",
            width: 120,
            showColumn: true,
            align: "center",
            sortable: "custom"
          },

          {
            prop: "star",
            label: "星标",
            width: 120,
            showColumn: true,
            align: "center",
            sortable: false
          },
          {
            prop: "seq",
            label: "次序",
            width: 120,
            showColumn: true,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "id",
            label: "ID",
            width: 80,
            showColumn: true,
            align: "center",
            sortable: "custom"
          },

          {
            prop: "user_name_create",
            label: "创建人",
            width: 100,
            showColumn: true,
            align: "left",
            sortable: "custom"
          },
          {
            prop: "utc_create",
            label: "创建时间",
            width: 120,
            showColumn: true,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "user_name_modified",
            label: "更新人",
            width: 100,
            showColumn: true,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "utc_modified",
            label: "更新时间",
            showColumn: true,
            width: 120,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "controlColumn",
            fixed: "right",
            align: "center",
            showColumn: true,
            label: "操作",
            width: 100
          }
        ];
      }
    },
    handleSizeChange(val) {
      this.page = 0;
      this.size = val;
      this.getTableData();
    },
    handlePageChange(val) {
      this.page = val - 1;
      this.getTableData();
    },

    onSearch() {
      this.page = 0;
      this.getTableData();
    },

    getTableData() {
      this.tableLoading = true;
      GetProductsList({
        page: this.page,
        size: this.size,
        sort: GetTableOrderParams(
          this.orderProp,
          this.orderDirection,
          this.orderPropObj
        ),
        disabled: this.showDisable,
        ...this.tableFilters
      })
        .then(res => {
          let { content, total_elements } = res.data;
          this.tableData = content;
          this.tableData = this.tableData.map(item => {
            return {
              ...item,
              canUpdate: true,
              canDisable: true,
              canUpdateSeries: true
            };
          });
          this.onUpdateCheck();
          this.onDisableCheck();
          this.onUpdateSeriesCheckCheck();
          this.total = total_elements;
          this.bindDataItem = null;
          // 加载状态结束
          this.tableLoading = false;
        })
        .catch(err => {
          this.tableLoading = false;
          ShowApiError("拉取列表错误", err);
        });
    },
    onRefresh() {
      this.getTableData();
    },
    onFilterChange(data) {
      this.tableFilters = data;
      this.page = 0;
      this.onSearch();
    },
    onClearAndRefresh() {
      this.orderProp = "seq";
      this.orderDirection = "descending";
      this.onResetFilter();
    },
    onResetFilter() {
      this.tableFilters = onClearFilter(this.tableFilters);
      this.page = 0;
      this.onRefresh();
    },
    onTableSortChange({ prop, order }) {
      if (order === null) {
        this.orderProp = "seq";
        this.orderDirection = "descending";
      } else {
        this.orderProp = prop;
        this.orderDirection = order;
      }
      this.onRefresh();
    },
    addRow() {
      this.$router.push({
        name: "ProductFormPage",
        params: {
          id: null
        }
      });
    },
    editRow(row) {
      if (row.canUpdate) {
        this.$router.push({
          name: "ProductFormPage",
          params: {
            id: row.id
          },
          query: {
            name: row.name.cn
          }
        });
      } else {
        this.$message.warning("没有权限执行此操作!");
      }
    },
    handleCopy(row) {
      this.$router.push({
        name: "ProductFormPage",
        params: {
          copyId: row.id
        },
        query: {
          name: row.name.cn
        }
      });
    },

    async onUpdateCheck() {
      try {
        let ids = this.tableData.map(item => item.id);
        if (ids.length > 0) {
          let res = await GetUpdateCheck(ids);
          this.tableData = this.tableData.map(item => {
            item.canUpdate = res.data;
            return item;
          });
        }
      } catch (error) {
        this.tableData = this.tableData.map(item => {
          item.canUpdate = true;
          return item;
        });
      }
    },
    async onDisableCheck() {
      try {
        let ids = this.tableData.map(item => item.id);
        if (ids.length > 0) {
          let res = await GetDisableCheck(ids);
          this.tableData = this.tableData.map(item => {
            item.canDisable = res.data;
            return item;
          });
        }
      } catch (error) {
        this.tableData = this.tableData.map(item => {
          item.canDisable = true;
          return item;
        });
      }
    },

    async onUpdateSeriesCheckCheck() {
      try {
        let ids = this.tableData.map(item => item.id);
        if (ids.length > 0) {
          let res = await GetUpdateSeriesCheck(ids);
          this.tableData = this.tableData.map(item => {
            item.canUpdateSeries = res.data;
            return item;
          });
        }
      } catch (error) {
        this.tableData = this.tableData.map(item => {
          item.canUpdateSeries = true;
          return item;
        });
      }
    },

    onFormCancel() {
      this.currentId = null;
      this.multipleFormDialog = false;
      this.formDialog = false;
    },

    onUpdateSerires() {
      let canUpdate = this.multipleSelected.every(
        item => item.canUpdateSeries == true
      );
      if (canUpdate) {
        this.showUpdateSeriesDialog = true;
      } else {
        this.$message.error("无权限操作");
      }
    },
    // 批量：启用/禁用
    onMultipleToggleDisable(flag = false) {
      if (this.multipleSelected.length <= 0) {
        return false;
      }
      let { ids, nameString, unableControl } = FormatMultipleItemIds({
        multipleSelectes: this.multipleSelected,
        nameKey: "nameCn"
      });
      let message = GetTableDisableMessage({
        total: this.multipleSelected.length,
        ableControlCount: ids.length,
        unableControlCount: unableControl.length,
        nameString: nameString,
        flag: flag,
        ableText: "启用",
        unAbleText: "禁用"
      });
      this.$msgbox({
        title: `${flag ? "禁用" : "启用"}提示`,
        message: message,
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (ids.length <= 0) {
              this.$message.info("无有效数据可操作");
              done();
              return;
            }
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "执行中...";
            ToogleDisableByIds(ids, flag)
              .then(() => {
                this.$message.success("操作成功");
                this.multipleSelected = [];
                this.onRefresh();
              })
              .catch(err => {
                ShowApiError("操作请求错误", err);
              })
              .finally(() => {
                done();
                instance.confirmButtonLoading = false;
                instance.confirmButtonText = "";
              });
          } else {
            instance.confirmButtonLoading = false;
            instance.confirmButtonText = "";
            done();
          }
        }
      });
    },

    onSelectionChange(selections) {
      this.multipleSelected = selections;
    },
    toggleDisableRow(row, index) {
      if (row.canDisable) {
        ToogleDisableByIds([row.id], !row.disabled).then(() => {
          row.disabled = !row.disabled;
          this.$set(this.tableData, index, row);
          this.$message.success("操作成功!");
        });
      } else {
        this.$message.warning("没有权限执行此操作!");
      }
    },

    onFormSuccess() {
      if (isEmprty(this.currentId)) {
        this.page = 0;
      }
      this.onRefresh();
    },

    onUpdateSeriesSuccess() {
      this.onRefresh();
      this.multipleSelected = [];
      this.onUpdateSeriesClose();
    },
    onUpdateSeriesClose() {
      this.showUpdateSeriesDialog = false;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-image__inner {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
